export const Logo = ({ size = "md", onClick, testid = "brand-logo", iconSize, textSize }) => {
  const icon = iconSize || (size === "lg" ? "h-11" : "h-8");
  const text = textSize || (size === "lg" ? "text-2xl" : "text-lg");
  return (
    <button onClick={onClick} className="flex items-center gap-2" data-testid={testid} aria-label="MoversNearby home">
      <img src="/images/logo-icon.png" alt="MoversNearby" className={`${icon} w-auto`} />
      <span className={`font-display ${text} font-bold uppercase leading-none tracking-tight`}>
        <span className="text-slate-900">Movers</span><span className="text-blaze">Nearby</span>
      </span>
    </button>
  );
};
